// extracted by mini-css-extract-plugin
module.exports = {"main_title":"News_main_title__rV-s7","person":"News_person__1B0Rz","photo":"News_photo__2_5M6","text":"News_text__sjVjw","name":"News_name__1tIWF"};